export const meta = {
  id: 'A13',
  slug: 'acompanhar-progresso',
  title: 'Como acompanhar seu progresso',
  description: 'Entenda como o progresso aparece em diferentes partes do seu desenvolvimento.',
  profile: 'student',
  category: 'progresso',
  type: 'concept',
  status: 'published',
  order: 170,
  keywords: ['progresso', 'percentual', 'evolução', 'aula', 'treinamento', 'formação', 'jornada', 'plano'],
  previous: 'A12',
  next: 'A13.1',
  related: ['A03', 'A05', 'A07', 'A09'],
  updatedAt: '2026-08-17',
  appVersion: 'v1'
}

# Como acompanhar seu progresso

O Personagrama pode mostrar progresso em diferentes níveis. Cada indicador responde a uma pergunta diferente, por isso é importante entender **o que aquele percentual ou status está medindo**.

## Onde o progresso pode aparecer

Você pode encontrar progresso em aulas, Treinamentos, componentes, etapas, Formações, Jornada, Plano e em outras áreas do seu desenvolvimento conforme a configuração disponível.

## Como interpretar

<Steps>
  <Step title="Observe o contexto do indicador">
    Identifique se o progresso se refere a uma aula, Treinamento, Formação, Jornada ou outro escopo.
  </Step>
  <Step title="Veja o que já foi concluído">
    Use os itens concluídos e pendentes para entender sua posição atual.
  </Step>
  <Step title="Procure a próxima ação">
    Progresso não é apenas um número: ele deve ajudar você a entender o que vem depois.
  </Step>
</Steps>

<Callout type="warning">
  Evite comparar percentuais de áreas diferentes como se medissem a mesma coisa. Cada progresso depende da estrutura e das regras daquele contexto.
</Callout>
